import React, { useContext } from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { useTexture } from '../../hooks';
import { getTextureUrl } from '../../utils';
import { TextLayerContext } from '../context';
import { GlowUse, ShadowUse, StrokeUse } from '../uses';

type Props = {
    /**
     * 图层数据
     */
    layer: ILayerProps;
    /**
     * svg 文本元素
     */
    textElements: JSX.Element[];
};

export const VerticalTextureDisplay: React.FC<Props> = ({ layer, textElements }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { id, width, height } = layer;
    const layerData = layer.data as ITextLayerProps;
    const texture = layerData.texture!;

    const { textureConfig } = useTexture(texture);

    const textureImageWidth = textureConfig?.stretch === 'repeat' ? textureConfig?.width || width : width;
    const textureImageHeight = textureConfig?.stretch === 'repeat' ? textureConfig?.height || height : height;
    const preserveAspectRatio = textureConfig?.stretch === 'repeat' ? 'none' : 'xMidYMid slice';

    const groupId = `text-${id}`;

    return (
        <React.Fragment>
            <defs>
                <g id={groupId}>{textElements}</g>
            </defs>

            <GlowUse href={`#${groupId}`} layer={layer} />
            <ShadowUse href={`#${groupId}`} layer={layer} />
            <StrokeUse href={`#${groupId}`} layer={layer} />

            {textElements.map((item, idx) => {
                const clipPathId = `clip-${id}-${idx}-${defIDSuffix}`;

                return (
                    <React.Fragment key={`vertical-texture-display-${id}-${idx}`}>
                        <defs>
                            <clipPath id={clipPathId}>{item}</clipPath>
                        </defs>

                        <image
                            data-texture-id={`texture-image-vertical-${id}`}
                            href={getTextureUrl(texture!.url)}
                            width={textureImageWidth}
                            height={textureImageHeight}
                            preserveAspectRatio={preserveAspectRatio}
                            clipPath={`url(#${clipPathId})`}
                        />
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};
